<template>
  <v-simple-table dense>
    
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Cantidad
          </th>
          <th class="text-left">
            Descripción
          </th>
          <th class="text-left">
            Precio
          </th>
          <th class="text-left">
            Descuento
          </th>
          <th class="text-left">
            Total
          </th>

        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in data"
          :key="item.idarticulo"
        >
          <td>{{ item.cantidad }}</td>
          <td>{{ item.nombre }}</td>
          <td>{{ item.preciocompra }}</td>
          <td>{{ item.descuento }}</td>
          <td>{{ (item.cantidad*item.preciocompra) | formatMoneda}}</td>
        </tr>
      </tbody>
      
      <tfoot>
        <tr>
          <td colspan="5">
            <v-divider></v-divider>
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>
            <p class="subtitle-2">Descuento</p>
            <h3 class="font-weight-black">Total</h3> 
          </td>
          <td>
            <p class="subtitle-2">Q {{totales.descuento}}</p>
            <h3 class="font-weight-black">Q {{totales.total}}</h3> 
          </td>
        </tr>
      </tfoot>
    </template>
  </v-simple-table>
</template>
<script>
import currency from "@/utils/currency.js";
  export default {
    props:["data","totales"],
    filters:{
      formatMoneda: function (value) {
        if (!value) return "";
        return currency(value, { precision: 2 });
      },
    }
  }
</script>
